import { useEffect } from 'react';
import { useOnboarding } from '../contexts/OnboardingContext';

/**
 * Hook para integrar o sistema de onboarding em qualquer página
 * @param {string} pageName - Nome da página (profissionais, servicos, locais, agendas)
 * @param {object} pageStats - Estatísticas específicas da página (opcional)
 * @returns {object} { hint, loading }
 */
export const usePageOnboarding = (pageName, pageStats = {}) => {
  const { getPageHint, userStats } = useOnboarding();

  if (!userStats) {
    return { hint: null, loading: true };
  }

  const hint = getPageHint(pageName, pageStats);
  return { hint, loading: false };
};

/**
 * Hook para atualizar as estatísticas do usuário
 * Deve ser chamado quando os dados são carregados
 * @param {object} stats - Objeto com as contagens { professionals, services, places, agendas }
 * @param {boolean} isLoading - Se os dados ainda estão carregando (opcional)
 */
export const useUpdateOnboardingStats = (stats, isLoading = false) => {
  const { updateStats } = useOnboarding();

  useEffect(() => {
    // Só atualiza se não estiver carregando e tiver stats
    if (stats && !isLoading) {
      updateStats(stats);
    }
  }, [stats, isLoading, updateStats]);
};
